import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useSearchParams, Link } from 'react-router-dom'
import { Layout, Form, Typography, Row, Input, Button, Alert, message } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'
import { getLoginAction } from '../../store/login/action-creators'
import { getLoadSessionAction } from '../../store/session/action-creators'
import { LOGIN_DONE } from '../../store/login/actions'
import { RESTORE_SESSION_DONE } from '../../store/session/actions'
import { IStore } from '../../store/interfaces'
import { getLocationFromRequestedQuery } from '../../../lib/utils/requested-query'
import { Logo } from '../../assets/icons/logo'
import { useAppDispatch } from '../../hooks/useAppDispatch/useAppDispatch'
import { getLoginErrorMessage } from './login-error'
import {
  LoginLayout,
  SiteLayout,
  ContentLayout,
  LoginForm,
  HeaderContainer,
  LogoContainer,
  Title,
  AccessMessage,
  ErrorAlert,
  StyledFormItem,
  ButtonContainer,
  Footer
} from './styles'

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
}
const tailLayout = {
  wrapperCol: { offset: 0, span: 24 },
}

export default function LoginPage () {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { lastResponse, hasErrors } = useSelector((state: IStore) => state.login)
  const [activeTab, setActiveTab] = useState('email')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [code, setCode] = useState('')
  const [step, setStep] = useState('phone') // 'phone' or 'code'
  const [loading, setLoading] = useState(false)
  const [sessionError, setSessionError] = useState<string | null>(null)

  const onFinish = async values => {
    setLoading(true)
    setSessionError(null)
    try {
      const loginFinalAction: any = await dispatch(getLoginAction(values))
      if (loginFinalAction.type === LOGIN_DONE) {
        const sessionFinalAction: any = await dispatch(getLoadSessionAction())
        if (sessionFinalAction.type === RESTORE_SESSION_DONE) {
          const from = searchParams.get('from')
          const nextLocation = from || getLocationFromRequestedQuery(location.search) || '/'
          navigate(nextLocation, { replace: true })
        } else {
          setSessionError(getLoginErrorMessage(sessionFinalAction.payload, true))
        }
      }
    } finally {
      setLoading(false)
    }
  }

  const onFinishFailed = errorInfo => {
    console.error('LoginPage: form failed', errorInfo)
  }

  const sendOTP = async (phone: string) => {
    setLoading(true)
    try {
      const response = await fetch('/api/sms/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone })
      })
      if (response.ok) {
        message.success('Код отправлен!')
        setStep('code')
      } else {
        message.error('Ошибка отправки')
      }
    } catch (err) {
      message.error('Ошибка сети')
    }
    setLoading(false)
  }

  const verifyOTP = async () => {
    setLoading(true)
    try {
      const response = await fetch('/api/sms/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phoneNumber, code })
      })
      if (response.ok) {
        const data = await response.json()
        // Адаптировать под Redux: dispatch login action с токеном или сессией
        const sessionFinalAction: any = await dispatch(getLoadSessionAction())
        if (sessionFinalAction.type === RESTORE_SESSION_DONE) {
          const from = searchParams.get('from')
          const nextLocation = from || getLocationFromRequestedQuery(location.search) || '/'
          navigate(nextLocation, { replace: true })
        }
      } else {
        message.error('Неверный код')
      }
    } catch (err) {
      message.error('Ошибка сети')
    }
    setLoading(false)
  }

  const currentYear = () => new Date().getFullYear()

  return (
    <LoginLayout>
      <SiteLayout className="site-layout">
        <ContentLayout>
          <Row justify="center" align="middle">
            <LoginForm
              {...layout}
              name="basic"
              layout="vertical"
              initialValues={{ }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError={true}
            >
              <HeaderContainer>
                <LogoContainer>
                  <Logo/>
                </LogoContainer>
                <Title>
                  Войти в аккаунт
                </Title>
                {hasErrors || sessionError ? (
                  <ErrorAlert
                    message={sessionError || getLoginErrorMessage(lastResponse)}
                    type="error"
                    showIcon
                  />
                ): null}
              </HeaderContainer>
              <StyledFormItem
                label="Логин:"
                name="login"
                rules={[
                  { required: true, message: 'Введите e-mail пользователя' },
                ]}
              >
                <Input />
              </StyledFormItem>
              <StyledFormItem
                label="Пароль:"
                name="password"
                rules={[
                  { required: true, message: 'Введите пароль' },
                ]}
              >
                <Input.Password />
              </StyledFormItem>
              <Form.Item {...tailLayout}>
                <ButtonContainer>
                  <Button type='primary' htmlType='submit' loading={activeTab === 'email' && loading}>
                    Войти <ArrowRightOutlined />
                  </Button>
                  {/*<Link className="login-form-forgot" to="/password-recovery"
                    style={{ fontSize: '90%' }}>
                    Забыли пароль?
                  </Link>*/}
                </ButtonContainer>
              </Form.Item>
            </LoginForm>

          </Row>
        </ContentLayout>
        <Footer>
          &copy; 2020-{currentYear()} ООО «Аксиома». Все права защищены.
        </Footer>
      </SiteLayout>
    </LoginLayout>
  )
}
